import { ChangeEvent, useState } from "react";
import GeneralInput from "../../common/GeneralInput";
import Modal from "../../common/Modal";
import { Car } from "../../../types/common.types";
import { AiFillCloseCircle } from "react-icons/ai";
import { useAdmin } from "../../../context/admin";
import AdminService from "../../../services/admin.service";
import { useGlobal } from "../../../context/global";

export default function CreateCar() {
    const { setIsLoading } = useGlobal()
    const { setIsCreateCarModalOpen } = useAdmin()
    const [data, setData] =  useState<Partial<Car>>({})

    function onChange(e: ChangeEvent<HTMLInputElement>) {
        const name = e.target.name
        const value = e.target.value
        setData((prevData) => ({...prevData, [name]: value}))
    }

    async function onSubmit(e: React.FormEvent<HTMLFormElement>) {
        e.preventDefault()
        console.log(data)
        setIsLoading(true)
        try {
            await AdminService.registerCar(data)
            window.location.reload()
        } catch (error) {
            console.log(error)
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <Modal onSubmit={onSubmit}>
            <h1>Create car</h1>
            <div className="input-container">
                <GeneralInput
                label="Brand"
                value={data.brand || ''}
                onChange={onChange}
                placeholder="Volkswagen"
                name="brand"
                style={{marginBottom: '20px'}}
                />
                <GeneralInput
                label="Model"
                value={data.model || ''}
                onChange={onChange}
                placeholder="Golf"
                name="model"
                style={{marginBottom: '20px'}}
                />
                <GeneralInput
                label="License plate"
                value={data.license_plate || ''}
                onChange={onChange}
                placeholder="ABC123"
                name="license_plate"
                style={{marginBottom: '20px'}}
                />
            </div>
            <div className="input-container">
                <GeneralInput
                label="Year"
                value={data.year || ''}
                onChange={onChange}
                type="number"
                placeholder="2020"
                name="year"
                style={{marginBottom: '20px'}}
                />
                <GeneralInput
                label="Seats"
                value={data.seats || ''}
                onChange={onChange}
                type="number"
                placeholder="5"
                name="seats"
                style={{marginBottom: '20px'}}
                />
                <GeneralInput
                label="Extra seats"
                value={data.extra_seats || ''}
                onChange={onChange}
                type="number"
                placeholder="2"
                name="extra_seats"
                style={{marginBottom: '20px'}}
                />
            </div>
            <div className="input-container">
                <GeneralInput
                label="Owner"
                value={data.owner || ''}
                onChange={onChange}
                placeholder="Jose Perez"
                name="owner"
                style={{marginBottom: '20px'}}
                />
                <GeneralInput
                label="RUT owner"
                value={data.rut_owner || ''}
                onChange={onChange}
                placeholder="12.345.678-9"
                name="rut_owner"
                style={{marginBottom: '20px'}}
                />
                <GeneralInput
                label="Phone owner"
                value={data.phone_owner || ''}
                onChange={onChange}
                placeholder="+56912345678"
                name="phone_owner"
                style={{marginBottom: '20px'}}
                />
            </div>
            <div className="actions">
                <button type="submit">Create car</button>
            </div>
            <div className="close"
            onClick={() => setIsCreateCarModalOpen(false)}
            >
                <AiFillCloseCircle/>
            </div>
        </Modal>
    )
}